import { apiClient } from '../infra/http/apiClient'

class MaintenanceService {
  /**
   * Get current maintenance mode status
   * @returns {Promise<{enabled: boolean}>} Promise object containing maintenance mode status
   */
  static async getMaintenanceMode() {
    try {
      const response = await apiClient.get('/maintenance-mode')
      return response.data
    } catch (error) {
      console.error('Failed to fetch maintenance mode:', error)
      throw this.handleError(error)
    }
  }

  /**
   * Set maintenance mode status
   * @param {boolean} enabled - Whether to enable maintenance mode
   * @returns {Promise<{enabled: boolean}>} Promise object containing updated maintenance mode status
   */
  static async setMaintenanceMode(enabled) {
    try {
      const response = await apiClient.post('/maintenance-mode', { enabled })
      return response.data
    } catch (error) {
      console.error('Failed to set maintenance mode:', error)
      throw this.handleError(error)
    }
  }

  /**
   * Handle API errors
   * @param {Error} error - Error object
   * @returns {Error} Formatted error
   */
  static handleError(error) {
    if (error.response) {
      // Server responded with error status
      const message = error.response.data?.message || error.response.statusText || 'An error occurred'
      const errorMessage = new Error(message)
      errorMessage.status = error.response.status
      errorMessage.code = error.response.data?.code
      return errorMessage
    } else if (error.request) {
      // Request was made but no response received
      return new Error('Network error: No response from server')
    } else {
      // Something else happened
      return error
    }
  }
}

export default MaintenanceService
